module.exports = __webpack_public_path__ + "img/compte.99dbcf6d.svg";